import { Component, ComponentFactoryResolver, OnInit } from "@angular/core";
import { Faq } from "../model/faq.model";
import { ApiService } from "../services/api.service";

@Component({
    selector: "ngx-faq",
    templateUrl: "./faq.component.html",
    styleUrls: ["./faq.component.scss"],
})
export class FaqComponent implements OnInit {
    public faqArray: Faq[] = [];
    faq: any;
    constructor(private _api: ApiService) {}

    ngOnInit(): void {
        this._api.getFaq(19).subscribe(async (res) => {
            this.faqArray = res;
            console.log(this.faqArray)
        });
    }
}
